import { IAuthService } from '../authentication/AuthService';

export interface IApiConfig {
	getAuthorization(): Promise<string>;
	getAuthService(): IAuthService;
}

export default class ApiConfig implements IApiConfig {
	private authService: IAuthService;

	constructor(authService: IAuthService) {
		this.authService = authService;
	}

	async getAuthorization(): Promise<string> {
		return `Bearer ${await this.authService.getAccessToken()}`;
	}

	getAuthService(): IAuthService {
		return this.authService;
	}
}
